export const environment = {
    title: process.env.REACT_APP_TITLE as string,
    production: Boolean(process.env.REACT_APP_PRODUCTION) as boolean,
    url: process.env.REACT_APP_URL as string,
    url_admin: process.env.REACT_APP_URL_ADMIN as string,
};